import React, { Component } from 'react';
import { useLocation } from 'react-router';
import { Link, withRouter } from 'react-router-dom';

import '../../index.css';
import Title from '../../components/Title';

function Terms({ history }) {
  const location = useLocation();
  const nameRef = React.useRef();
  const [data, setData] = React.useState(location.state);

  const [check, setCheck] = React.useState({
    userNameCheck: data.userName ? true : false,
    termCheck: false,
  });

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const [aTerm, setATerm] = React.useState(false);
  const [mTerm, setMTerm] = React.useState(false);
  const [sTerm, setSTerm] = React.useState(false);

  const [nextBtnDisabled, setNextBtnDisabled] = React.useState(false);
  console.log(nextBtnDisabled);
  React.useEffect(() => {
    let v = check.userNameCheck && check.termCheck;
    setNextBtnDisabled(!v);
  }, [check]);

  const setAllCheck = (isChecked) => {
    if (!isChecked) {
      setSTerm(true);
      setMTerm(true);
      setCheck({ ...check, termCheck: true });
      setData({ ...data, serviceTerm: 1, marketingTerm: 1 });
    } else {
      setSTerm(false);
      setMTerm(false);
      setCheck({ ...check, termCheck: false });
      setData({ ...data, serviceTerm: 0, marketingTerm: 0 });
    }
  };

  return (
    <div>
      <Title title="약관 동의" />
      <div style={{ marginBottom: 80 }}>
        <p
          style={{
            fontSize: 18,
            color: check.userNameCheck ? '#000' : '#FF8A00',
          }}
        >
          담당자명*
        </p>
        <div className="input-box" style={{ display: 'flex' }}>
          <input
            type="text"
            name="userName"
            value={data.userName}
            onChange={(e) => {
              handleChange(e);
              nameRef.current.value.length > 0
                ? setCheck({ ...check, userNameCheck: true })
                : setCheck({ ...check, userNameCheck: false });
            }}
            ref={nameRef}
            style={{
              width: 188,
              height: 38,
              borderRadius: '5px',
              border: 0,
              outline: check.userNameCheck
                ? '1px solid #C4C4C4'
                : '1px solid #FF8A00',
            }}
          />

          <p
            style={{
              color: '#FF8A00',
              marginLeft: '10px',
            }}
          >
            {check.userNameCheck
              ? '담당자명이 입력되었습니다.'
              : '담당자명은 반드시 입력해야 합니다.'}
          </p>
        </div>
      </div>
      <div>
        <div className="checkbox-list">
          <input
            type="checkbox"
            id="terms1"
            name="terms1"
            checked={aTerm}
            onChange={() => {
              setATerm(!aTerm);
              setAllCheck(aTerm);
            }}
          />
          <label htmlFor="terms1">
            <span>전체 동의</span>
          </label>
        </div>

        <div className="checkbox-list">
          <input
            type="checkbox"
            id="serviceTerm"
            name="serviceTerm"
            checked={sTerm}
            onChange={() => {
              setSTerm(!sTerm);
              setCheck({ ...check, termCheck: !sTerm });
              setData({ ...data, serviceTerm: sTerm ? 0 : 1 });
            }}
          />
          <label htmlFor="serviceTerm">
            <span
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              <div className="dropDown">
                <div style={{ textDecoration: 'underline' }}>
                  서비스 이용약관
                </div>
                <div className="dropDownMenu">
                  <div className="dropDown-bubble">
                    <div
                      onClick={(event) => {
                        // event.preventDefault();
                      }}
                    >
                      <a
                        style={{ textDecoration: 'underline' }}
                        href="https://dazzling-whale-1af.notion.site/24-42655ce0a460498c98462887a7921709"
                        target="_blank"
                        rel="noreferrer"
                      >
                        서비스 이용약관
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ width: '4px' }} /> 및
              <div style={{ width: '4px' }} />
              <div className="dropDown">
                <div style={{ textDecoration: 'underline' }}>
                  개인정보 이용방침
                </div>
                <div className="dropDownMenu">
                  <div className="dropDown-bubble">
                    <div
                      onClick={(event) => {
                        // event.preventDefault();
                      }}
                    >
                      <a
                        style={{ textDecoration: 'underline' }}
                        href="https://dazzling-whale-1af.notion.site/24-46df0fb9597f4cc598ac9db60707fe1c"
                        target="_blank"
                        rel="noreferrer"
                      >
                        개인정보 처리방침
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              에 동의합니다.
            </span>
          </label>
        </div>
        <div className="checkbox-list">
          <input
            type="checkbox"
            id="marketingTerm"
            name="marketingTerm"
            checked={mTerm}
            onChange={() => {
              setMTerm(!mTerm);
              setData({ ...data, marketingTerm: mTerm ? 0 : 1 });
            }}
          />
          <label htmlFor="marketingTerm">
            <span>마케팅 정보 수신에 동의합니다. (선택)</span>
          </label>
        </div>
        {sTerm ? (
          <></>
        ) : (
          <p style={{ color: 'red', paddingLeft: 12 }}>
            * 서비스 이용약관 및 개인정보 처리방침에 동의해주세요.
          </p>
        )}
      </div>
      <div className="footer-div">
        <button
          className={nextBtnDisabled ? 'rounded-button-g' : 'rounded-button-y'}
          disabled={nextBtnDisabled}
          onClick={() => {
            window.sessionStorage.setItem('data', JSON.stringify(data));
            history.push({
              pathname: '/signup/account',
            });
          }}
        >
          다음
        </button>
      </div>
    </div>
  );
}

export default withRouter(Terms);
